import { getActiveBasketItem, loadBasketJourney } from '../services/BasketJourneyService';
import { VERSION } from '../services/EnvironmentService';

export const loadStateFromSessionStorage = () => {
	try {
		const journey = loadBasketJourney();
		const activeItem = getActiveBasketItem(journey);
		const serializedState = sessionStorage.getItem(getSessionKey());
		const basket = activeItem
			? journey.items.map(({ basketItemId, ...item }) => ({
					...item,
					entryId: basketItemId,
					prefix: Number(basketItemId.slice(basketItemId.lastIndexOf('#') + 1)),
				}))
			: undefined;
		if (!serializedState) {
			if (basket) return { basket };
			return undefined; // No state in sessionStorage
		}

		const state = JSON.parse(serializedState);
		return basket ? { ...state, basket } : state;
	} catch (err) {
		console.error('Failed to load sessionStorage', err);
		return undefined; // Handle errors e.g. JSON parsing errors
	}
};

export const saveStateToSessionStorage = (state: any) => {
	try {
		const serializedState = JSON.stringify(removeStoreSlices(state));
		sessionStorage.setItem(getSessionKey(), serializedState);
		//TODO Clear browser history state to prevent going back to cleared state with back button after finishing,
		// as this can cause bugs if user goes back to a page with forms and then forward again to receipt page.
	} catch (err) {
		console.error('Failed to save sessionStorage', err);
	}
};

export const removeStateFromSessionStorage = () => {
	try {
		sessionStorage.removeItem(getSessionKey());
		sessionStorage.removeItem('reloaded');
	} catch (err) {
		console.error('Failed to remove sessionStorage', err);
	}
};

const excludeSlicesFromStorage = ['customer', 'customerProducts', 'modal'];

export const removeStoreSlices = (state) => {
	if (!state) {
		return state;
	}
	const stateCopy = { ...state };
	excludeSlicesFromStorage.forEach((key) => {
		stateCopy[key] = {};
	});
	return stateCopy;
};

const getSessionKey = (): string => {
	const insuranceId = location.pathname.split('/')?.filter(Boolean)?.pop();
	// insuranceId = indbo, rejse etc...
	const key = `redux-state-${insuranceId || ''}-${VERSION}`;
	const journey = loadBasketJourney();
	const activeItem = getActiveBasketItem(journey);
	return activeItem ? `${key}-basket-${journey.sessionId}-${encodeURIComponent(activeItem.basketItemId)}` : key;
};
